import * as z from "zod";

export const UploadedFileSchema = z.object({
  file_id: z.union([z.string(), z.number()]),
  original_filename: z.string(),
  preview_pdf_url: z.string(),
  pages_count: z.number(),
  original_url: z.string().nullable().optional(),
});

export const UploadFilesResponseSchema = z.object({
  files: z.array(UploadedFileSchema),
});
